@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;
@use '../../styling/form-controls.scss' as *;

.GridFieldset {
  display: grid;
  grid-auto-flow: row;
  grid-template-rows: 100%;
  border: 0;
  padding: 0;
  margin: 0;

  > legend {
    @extend %form-control-label-font;
    width: 100%;
    margin-bottom: 8px;
    padding: 0;
    align-items: start;

    > span:first-child {
      display: flex;
      width: 14px;
    }

    .DescriptionAlignment {
      padding-top: 3px;
    }

    &.WithAndWithoutDescription {
      display: flex;
    }

    &.PaddingLeft {
      padding-left: 18px;
    }

    &.PaddingRight {
      padding-right: 18px;
    }

    &.PaddingTop {
      padding-top: 18px;
    }

    &.PaddingBottom {
      padding-bottom: 10px; // legend has own margin bottom of 8px already
    }

    &.DescriptionAndQuery {
      display: grid;
      grid-template-columns: auto auto auto 1fr; /* header, requireIcon, Description, Query */
    }

    &.QueryOnly {
      display: grid;
      width: 100%;
      grid-template-columns: auto auto 1fr; /* Header, requireIcon, Query */
    }

    .RequiredIcon {
      display: grid;
      width: 14px;
    }

    > h3 {
      padding-right: 5px;
    }
    
    .Query {
      width: 100%;
    }
  }

  &.hasBorderTop {
    margin-top: 36px;

    > legend {
      border-top: 1px solid $theme-color-borders;
      padding-top: 16px;
      width: 100%;
      height: 24px;
      margin-bottom: calc(1em + 10px + 2px); // default header have padding top 10px
    }
  }

  &.parentOverflowHidden {
      overflow: hidden;
  }

  .GridChildren {
    display: grid;
    row-gap: 18px;
    grid-auto-flow: row;
    grid-auto-columns: minmax(0, 1fr); // ensure the width allocation is not depending on child max width
    // Prevent shadow been cut away due to overflow
    padding: 3px;
    margin: -3px;

    &.extraBorderTop {
      margin-top: 14.5px; // default header have padding top 10px
    }

    &.isOverflow {
      overflow: auto;
      grid-template-rows: 100%;
    }

    &.isOverflowHidden {
      overflow: hidden;
    }

    &.hasBackground {
      background: $theme-color-input-readonly;
      border-radius: 6px;
    }
  }
}
